import { render } from "./waitinglist.vue?vue&type=template&id=3cbaf90c"
import script from "./waitinglist.vue?vue&type=script&lang=js"
export * from "./waitinglist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__